import {SupplierInitValues, SupplierModel} from '../../suppliers/models/SupplierModel'

interface PurchaseOrderItem {
  _id: string
  product: string
  name: string
  UOM: string
  quantity: number | string
  rate: number | string
  price: number | string
  tax: number | string
  priceInclusiveTax: number | string
  discount: number | string
  total: number | string
  status: string
}

export interface PurchaseOrderModel {
  _id: string
  purchaseFor: string
  number: string
  totalPrice: number | string
  totalTax: number | string
  totalDiscount: number | string
  totalAmount: number | string
  status: string
  approvedAt?: string
  approvedBy?: string
  rejectedBy?: string
  rejectedAt?: string
  rejectionReason?: string
  supplier: SupplierModel
  items: [PurchaseOrderItem]
}

export const PurchaseOrderInitValues: PurchaseOrderModel = {
  _id: '',
  number: '',
  purchaseFor: '',
  totalPrice: '',
  totalTax: '',
  totalDiscount: '',
  totalAmount: '',
  status: '',
  approvedAt: '',
  approvedBy: '',
  rejectedBy: '',
  rejectedAt: '',
  rejectionReason: '',
  supplier: SupplierInitValues,
  items: [
    {
      _id: '',
      product: '',
      name: '',
      UOM: '',
      quantity: '',
      rate: '',
      price: '',
      tax: '',
      priceInclusiveTax: '',
      discount: '',
      total: '',
      status: '',
    },
  ],
}

export interface PurchaseOrderSearchModel {
  number: string
  status: string
  createdAt: any
  supplier: string
  totalAmount: string
  approvedBy: string
  approvedAt: any
}
export const PurchaseOrderSearchModelInitValues: PurchaseOrderSearchModel = {
  number: '',
  status: '',
  createdAt: [],
  supplier: '',
  totalAmount: '',
  approvedBy: '',
  approvedAt: [],
}

export interface PurchaseOrderTableModel {
  page: number
  sortBy: string
  sortOrder: string
  search: PurchaseOrderSearchModel
}

export const PurchaseOrderTableModelInitValues: PurchaseOrderTableModel = {
  page: 1,
  sortBy: 'createdAt',
  sortOrder: 'desc',
  search: PurchaseOrderSearchModelInitValues,
}
